
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bike-parts/[make]/[model]/[city]",
      function () {
        return require("private-next-pages/bike-parts/[make]/[model]/[city]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bike-parts/[make]/[model]/[city]"])
      });
    }
  